export default {
  data () {
    return {
      errorMessage: null,
      errorText: 'we encountered an issue.',
    }
  },

  methods: {
    setLoadError(error) {
      this.errorMessage = `${this.errorText} ${error}`
    },
  }
}